import { Box, HStack, Text } from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { Href } from "../../../../../components/Href";
import { Icon } from "../../../../../components/Icon";
import {
  getMenuItemAdapterType,
  getMenuItemAdapterValues,
} from "../../../../../helpers/menus/getMenuItemAdapterValues";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
 *
 * @param {Props} props
 */
export function MenuItem({ menuItem }) {
  const translate = useTranslate();

  if (getMenuItemAdapterType({ menuItem }) === undefined) {
    return null;
  }

  const { title, href, target } = getMenuItemAdapterValues({
    menuItem,
    translate,
  });

  return (
    <Box>
      <Href href={href} target={target}>
        <HStack
          borderBottomWidth="1px"
          borderColor="brandPrimary.500"
          py="0.8125rem">
          <Text variant="header" flexGrow={1}>
            {title}
          </Text>

          <Box>
            <Icon icon="ms_chevron_right" size="1.5rem" />
          </Box>
        </HStack>
      </Href>

      {menuItem.children.map((menuItem, index) => {
        return <MenuItem menuItem={menuItem} key={index} />;
      })}
    </Box>
  );
}
